"use client";
import { Button } from "@workspace/frontend-ui";

type Props = {
  message: string;
  retryLabel: string;
  isPending: boolean;
  onRetry: () => void;
};

const SectionRetry: FC<Props> = ({
  message,
  retryLabel,
  isPending,
  onRetry,
}) => (
  <div
    data-slot="section-retry"
    className="flex min-h-48 flex-col items-center justify-center gap-3 rounded-xl border border-dashed p-6 text-center"
  >
    <p className="text-sm text-muted-foreground">{message}</p>
    <Button
      variant="secondary"
      size="sm"
      disabled={isPending}
      aria-busy={isPending}
      onClick={onRetry}
    >
      {retryLabel}
    </Button>
  </div>
);

export default SectionRetry;
